import { useMutation, useQuery } from "@tanstack/react-query";
import { apiV2 } from "libs/api/src/lib/apiV2";
import { useTranslation } from "react-i18next";

import { Spinner, Switch } from "../../atoms";

export const MemberMarketingOptionsForm = ({
  memberId,
}: {
  memberId: string;
}) => {
  const { t } = useTranslation();

  const { data: member } = useQuery(apiV2.staff.member.queries.id(memberId));

  const updateCommunicationMutation = useMutation(
    apiV2.staff.member.mutations.updateCommunication(),
  );

  if (!member) return <Spinner />;

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col gap-y-2 p-6">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col gap-y-2">
            <div className="inline-flex text-sm font-semibold">
              {t("pages.member.marketing.emailMarketing")}
            </div>
            <div className="inline-flex text-sm text-gray-400">
              {t("pages.member.marketing.emailMarketingDescription")}
            </div>
          </div>
          <Switch
            value={member.emailCommunication}
            onChange={async (checked) => {
              await updateCommunicationMutation.mutateAsync({
                userId: memberId,
                patch: {
                  emailCommunication: checked,
                },
              });
            }}
          />
        </div>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col gap-y-2">
            <div className="inline-flex text-sm font-semibold">
              {t("pages.member.marketing.smsMarketing")}
            </div>
            <div className="inline-flex text-sm text-gray-400">
              {t("pages.member.marketing.smsMarketingDescription")}
            </div>
          </div>
          <Switch
            value={member.smsCommunication}
            onChange={async (checked) => {
              await updateCommunicationMutation.mutateAsync({
                userId: memberId,
                patch: {
                  smsCommunication: checked,
                },
              });
            }}
          />
        </div>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col gap-y-2">
            <div className="inline-flex text-sm font-semibold">
              {t("pages.member.marketing.pushNotifications")}
            </div>
            <div className="inline-flex text-sm text-gray-400">
              {t("pages.member.marketing.pushNotificationsDescription")}
            </div>
          </div>
          <Switch
            value={member.pushCommunication}
            onChange={async (checked) => {
              await updateCommunicationMutation.mutateAsync({
                userId: memberId,
                patch: {
                  pushCommunication: checked,
                },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};
